export const USE_API=true;

const dev = {
	API_ENDPOINT_URL: 'http://127.0.0.1:8000/api',
	X_API_KEY:'123456',
	WEB_URL:'http://127.0.0.1:8000',
	VERSION_APP:'2024.1.1'
};

const prod = {
	API_ENDPOINT_URL: 'https://apisifo.fokusjasamitra.com/api',
	X_API_KEY:'6Q6ZZnB3FvXb',
	WEB_URL:'https://sifo.fokusjasamitra.com',
	VERSION_APP:'2026.5.3'
};

const test = {
  API_ENDPOINT_URL: '/api'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
